import { BookOpen, ExternalLink } from "lucide-react";
import { useLang } from "../i18n/LangContext";

// «Σχετικές εργασίες – δημοσιεύσεις» — βιβλιογραφία του ομηρικού ζητήματος
export const PublicationsPage = () => {
  const { d, ui } = useLang();
  return (
    <main data-testid="pubs-main" className="min-h-[70vh] bg-surface/50">
      <div className="mx-auto max-w-4xl px-6 pb-14 pt-10">
        <p className="eyebrow">{ui.pubsEyebrow}</p>
        <h1 data-testid="pubs-title" className="mt-2 font-serif text-3xl font-semibold tracking-tight text-ink md:text-5xl">
          {ui.heroOptPubs}
        </h1>
        <p className="mt-6 max-w-3xl text-base leading-relaxed text-muted-foreground md:text-lg">{ui.pubsIntro}</p>

        <div className="mt-12 flex items-center gap-4">
          <div className="rounded-full bg-aegean p-3 text-paper">
            <BookOpen className="h-5 w-5" />
          </div>
          <h2 className="font-serif text-2xl font-semibold tracking-tight text-ink md:text-3xl">{ui.biblioTitle}</h2>
        </div>
        <h3 data-testid="pubs-classic-title" className="mt-8 font-serif text-lg font-semibold text-ink md:text-xl">{ui.biblioClassicTitle}</h3>
        <ul className="mt-6 space-y-5">
          {d.BIBLIOGRAPHY_CLASSIC.map((b, i) => (
            <li
              key={i}
              data-testid={`pubs-classic-item-${i}`}
              className="rounded-xl border border-line bg-paper p-5 text-sm leading-relaxed text-foreground/85 transition-colors duration-150 hover:border-aegean/50 md:text-base"
            >
              {b.text}
              {b.url && (
                <a
                  href={b.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`pubs-classic-link-${i}`}
                  className="mt-3 flex items-center justify-end gap-1.5 text-sm font-semibold text-aegean transition-colors hover:text-terra"
                >
                  {ui.pubsLinkLabel}
                  <ExternalLink className="h-3.5 w-3.5" aria-hidden />
                </a>
              )}
            </li>
          ))}
        </ul>

        <h3 data-testid="pubs-recent-title" className="mt-12 font-serif text-lg font-semibold text-ink md:text-xl">{ui.biblioRecentTitle}</h3>
        <ul className="mt-6 space-y-5">
          {d.BIBLIOGRAPHY_RECENT.map((b, i) => (
            <li
              key={i}
              data-testid={`pubs-recent-item-${i}`}
              className="rounded-xl border border-line bg-paper p-5 text-sm leading-relaxed text-foreground/85 transition-colors duration-150 hover:border-aegean/50 md:text-base"
            >
              {b.text}
              {b.url && (
                <a
                  href={b.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`pubs-recent-link-${i}`}
                  className="mt-3 flex items-center justify-end gap-1.5 text-sm font-semibold text-aegean transition-colors hover:text-terra"
                >
                  {ui.pubsLinkLabel}
                  <ExternalLink className="h-3.5 w-3.5" aria-hidden />
                </a>
              )}
            </li>
          ))}
        </ul>
        <p className="mt-8 text-sm leading-relaxed text-muted-foreground">{ui.pubsNote}</p>
      </div>
    </main>
  );
};
